/**
 * Сборка словарей по областям. Каждую область правит один файл, ключи
 * областей не пересекаются (префикс: 'settings.', 'feed.' и т.д.).
 */
import { common } from './common';
import { lib } from './lib';
import { app } from './app';
import { components } from './components';
import { pagesEnvelope } from './pages-envelope';
import { pagesEnvelopes } from './pages-envelopes';
import { pagesFeed } from './pages-feed';
import { pagesObligations } from './pages-obligations';
import { pagesSettings } from './pages-settings';

const parts = [common, lib, app, components, pagesEnvelope, pagesEnvelopes, pagesFeed, pagesObligations, pagesSettings] as const;

type Merge<P extends readonly { ru: object }[]> = P extends readonly [infer H extends { ru: object }, ...infer T extends { ru: object }[]]
  ? H['ru'] & Merge<T>
  : unknown;
type All = Merge<typeof parts>;

function merge(lang: 'ru' | 'en' | 'be'): All {
  return Object.assign({}, ...parts.map((p) => p[lang])) as All;
}

export const messages = { ru: merge('ru'), en: merge('en'), be: merge('be') };
